import { render, staticRenderFns } from "./SKIconBagi.vue?vue&type=template&id=7a9aa424&scoped=true&"
import script from "./SKIconBagi.vue?vue&type=script&lang=js&"
export * from "./SKIconBagi.vue?vue&type=script&lang=js&"
import style0 from "./SKIconBagi.vue?vue&type=style&index=0&id=7a9aa424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9aa424",
  null
  
)

export default component.exports